import { Navigate, useLocation } from "react-router";

interface LocationPreservingRedirectProps {
  pathname: string;
  hash?: string;
}

const LocationPreservingRedirect = ({
  pathname,
  hash: configuredHash
}: LocationPreservingRedirectProps) => {
  const { search, hash, state } = useLocation();

  return (
    <Navigate
      to={{
        pathname,
        search,
        hash: configuredHash || hash
      }}
      replace
      state={state}
    />
  );
};

export { LocationPreservingRedirect };
